// @ts-nocheck - TODO: Fix type errors once API client is fully migrated in Phase 4
import type { OoJobService } from "../networking/generated/api-client";

export interface ConsultantAvatarItem {
	imageUrl: string;
	name: string;
	status: "PENDING_ANSWER" | "DECLINED" | "CANCELLED" | "ACCEPTED";
	id: string;
	consultantId?: string;
	hasRated?: boolean;
}

export interface AllConsultantData {
	appliedConsultants: ConsultantAvatarItem[];
	invitedConsultants: ConsultantAvatarItem[];
}

export const getApplicantConsultantData = (
	statusList: string[],
	job?: OoJobService.GetJobJobIdResponse,
): ConsultantAvatarItem[] => {
	if (!job?.applications) return [];
	return job?.applications
		?.filter((app) => statusList.includes(app.status))
		.map((item) => ({
			imageUrl: item.consultant.profile?.profilePicture ?? "",
			name: item.consultant.firstName,
			status: item.status,
			id: item.id,
			consultantId: item.consultant.id,
			hasRated: item.consultant?.rating?.id ? true : false,
		}));
};

export const getFilteredConsultantData = (
	invitationStatusList: string[],
	applicationStatusList: string[],
	applications?: OoJobService.GetJobJobIdResponse["applications"],
	invitations?: OoJobService.GetJobJobIdResponse["invitations"],
): AllConsultantData => {
	if (!invitations && !applications) return { appliedConsultants: [], invitedConsultants: [] };
	const allConsultantListData: AllConsultantData = { appliedConsultants: [], invitedConsultants: [] };

	if (applications && applications.length > 0) {
		applications
			.filter((application) => applicationStatusList.includes(application.status))
			.forEach((app) => {
				allConsultantListData.appliedConsultants.push({
					imageUrl: app.consultant.profile?.profilePicture ?? "",
					name: app.consultant.firstName ?? "",
					status: app.status,
					id: app.id,
					consultantId: app.consultant.id,
				});
			});
	}

	if (invitations && invitations.length > 0) {
		invitations
			.filter((invitation) => invitationStatusList.includes(invitation.status))
			.forEach((invi) => {
				allConsultantListData.invitedConsultants.push({
					imageUrl: invi.consultant.profile?.profilePicture ?? "",
					name: invi.consultant.firstName ?? "",
					status: ["DECLINED", "EXPIRED"].includes(invi.status) ? "DECLINED" : "PENDING_ANSWER",
					id: invi.id,
					consultantId: invi.consultant.id,
				});
			});
	}

	return allConsultantListData;
};
